import { type FC } from 'react'
import cx from 'classnames'
import { twMerge } from 'tailwind-merge'
import { type DefaultProps } from '../common'

export const EvergreenWealthLogo: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  const baseClass = cx({
    'h-6 w-auto text-white': true,
  })

  // Final class names
  const finalClasses = twMerge(baseClass, className)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 138 10"
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      className={finalClasses}
    >
      <path
        d="M89.6916 9.56522H89.1004L86.4062 0.220703H87.0589L89.435 8.59494L92.0231 0.220703H92.8264L95.4591 8.59494L97.6958 0.220703H98.3596L95.7436 9.56522H95.1523L92.4136 0.893288L89.6916 9.56522Z"
        fill="currentColor"
      />
      <path
        d="M100.373 9.56522V0.220703H105.209L105.789 0.788542H101.009V4.61456H104.445L105.003 5.16586H101.009V8.99187H105.226L105.789 9.55971H100.373V9.56522Z"
        fill="currentColor"
      />
      <path
        d="M114.876 9.56522H114.223L113.119 6.64885H108.656L107.552 9.56522H106.916L110.53 0.220703H111.317L114.87 9.56522H114.876ZM110.915 0.772002L108.891 6.08101H112.901L110.921 0.772002H110.915Z"
        fill="currentColor"
      />
      <path d="M116.498 9.56522V0.220703H117.134V8.98085H121.328L121.914 9.56522H116.498Z" fill="currentColor" />
      <path
        d="M125.424 0.80508V9.56522H124.788V0.80508H121.447V0.220703H128.169L128.765 0.80508H125.424Z"
        fill="currentColor"
      />
      <path
        d="M136.963 9.56522V5.15483H131.062V9.56522H130.426V0.220703H131.062V4.60353H136.963V0.220703H137.599V9.56522H136.963Z"
        fill="currentColor"
      />
      <mask id="mask0_1619_5254" maskUnits="userSpaceOnUse" x="0" y="0" width="84" height="10">
        <path d="M83.6678 0H0V9.758H83.6678V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1619_5254)">
        <path
          d="M-0.000281396 9.53766V0.220703H5.89551L6.44771 1.75332H1.8181V4.09082H5.08114L5.61661 5.62344H1.81252V7.99402H5.90108L6.43656 9.52663H-0.00585938L-0.000281396 9.53766Z"
          fill="currentColor"
        />
        <path
          d="M18.8083 9.53766V0.220703H24.7041L25.2563 1.75332H20.6267V4.09082H23.8897L24.4252 5.62344H20.6323V7.99402H24.7208L25.2563 9.52663H18.8027L18.8083 9.53766Z"
          fill="currentColor"
        />
        <path
          d="M57.4512 9.53766V0.220703H63.347L63.8992 1.75332H59.2751V4.09082H62.5382L63.0736 5.62344H59.2807V7.99402H63.3693L63.9047 9.52663H57.4512V9.53766Z"
          fill="currentColor"
        />
        <path
          d="M66.4372 9.53766V0.220703H72.333L72.8852 1.75332H68.2556V4.09082H71.5187L72.0541 5.62344H68.2612V7.99402H72.3497L72.8852 9.52663H66.4316L66.4372 9.53766Z"
          fill="currentColor"
        />
        <path
          d="M13.5262 9.53766H11.2895L7.93164 0.220703H9.83369L12.4162 7.70183L14.9988 0.220703H16.9008L13.5095 9.53766H13.5151H13.5262Z"
          fill="currentColor"
        />
        <path
          d="M29.6412 9.53766H27.7949V0.220703C27.7949 0.220703 31.1416 0.220703 31.1137 0.220703C33.5011 0.220703 34.7784 1.33984 34.7784 3.05438C34.7784 4.38301 34.0254 5.30368 32.7369 5.73921L35.219 9.54317H33.1218L31.0245 6.13063L29.6635 6.22435V9.54869H29.6468L29.6412 9.53766ZM31.0022 4.75238C32.1401 4.69725 32.8763 4.19006 32.8763 3.17567C32.8763 2.16128 32.1401 1.74229 30.8181 1.74229H29.6245V4.77995L31.0022 4.75238Z"
          fill="currentColor"
        />
        <path
          d="M41.6719 9.758C38.7658 9.758 36.7578 7.92217 36.7578 4.90105C36.7578 1.87993 38.7547 0 41.6886 0C42.8377 0 44.1875 0.297701 45.0353 0.804896L44.4497 2.38161C43.6186 1.87442 42.6592 1.56018 41.7277 1.56018C39.8535 1.56018 38.6264 2.82817 38.6264 4.84041C38.6264 6.85265 39.7922 8.21987 41.7277 8.21987C42.3914 8.21987 43.044 8.05448 43.507 7.8505V6.05878H41.5659L41.0249 4.52617H45.2194V8.87592C44.2042 9.43824 42.8711 9.75248 41.6775 9.75248L41.6719 9.758Z"
          fill="currentColor"
        />
        <path
          d="M49.7545 9.53766H47.9082V0.220703C47.9082 0.220703 51.2549 0.220703 51.227 0.220703C53.6143 0.220703 54.8917 1.33984 54.8917 3.05438C54.8917 4.38301 54.1387 5.30368 52.8502 5.73921L55.3323 9.54317H53.2351L51.1378 6.13063L49.7768 6.22435V9.54869H49.76L49.7545 9.53766ZM51.1155 4.75238C52.2533 4.69725 52.9896 4.19006 52.9896 3.17567C52.9896 2.16128 52.2534 1.74229 50.9314 1.74229H49.7377V4.77995L51.1155 4.75238Z"
          fill="currentColor"
        />
        <path
          d="M83.662 0.220357V9.62001H81.693L77.1694 2.76185V9.52629H75.418V0.214844H77.4316L81.905 7.00134V0.214844H83.662V0.220357Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
